import { swRequest } from "@sourcewhale/core";

export const parseResumes = (body) =>
  swRequest({
    path: "/api/resumes/parse",
    method: "POST",
    body,
  });
